import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Skeleton } from "@parkschannel/ui";
export const CarouselItemSkeleton = ()=>{
    return /*#__PURE__*/ _jsx("div", {
        className: "w-[200px] h-[140px]",
        children: /*#__PURE__*/ _jsx("div", {
            className: "w-full h-full mr-3",
            children: /*#__PURE__*/ _jsx(Skeleton, {
                variant: "rounded",
                width: 192,
                height: 140,
                animation: "animate-shimmer"
            })
        })
    });
};
